
const PlayMode = {};
export default PlayMode;

PlayMode.ASSESSMENT = "assessment";
PlayMode.DEMO = "demo";